import Descriptions from './src'

Descriptions.install = function install(Vue) {
  Vue.component(Descriptions.name, Descriptions)
}

export default Descriptions
